import { classListSupport, hasClass } from './hasClass.js';
var removeClass = classListSupport ?
    function (el, str) {
      if (hasClass(el,  str)) { el.classList.remove(str); }
    } :
    function (el, str) {
      if (hasClass(el, str)) { el.className = el.className.replace(str, ''); }
    };

export { removeClass };


//////////////////
// WEBPACK FOOTER
// /Users/martin/Sites/turnbull-cms/site/web/app/themes/sage/node_modules/tiny-slider/src/helpers/removeClass.js
// module id = 34
// module chunks = 0